import React, { Component } from 'react';

export default class Select extends Component {
  render() {
    return (
      <select
        id={this.props.id}
        onChange={this.props.onChange}
        value={this.props.selectedIndex}
      >
        <option key={0} value={-1}>
          Not used
        </option>
        {this.props.options &&
          this.props.options.map((o, i) => (
            <option key={i + 1} value={i}>
              {o}
            </option>
          ))}
      </select>
    );
  }
}
